import {
  Wind, RefreshCw, CloudRain, Flame, Baby, Users, Globe, Compass, Sprout,
  Puzzle, Heart, Sparkles, Brain, Sun, Moon, Leaf, Anchor, Shield, Smile,
  Star, Feather, Waves, Mountain, Cloud, Lightbulb, Handshake, HeartHandshake,
  HandHeart, BookOpen, MessageCircle, Coffee, Home, Activity, Accessibility,
} from "lucide-react";

// Single source of truth for the icons available to Treatment tiles and the
// spotlight note. Used by both the public site and the admin editor.
export const TREATMENT_ICONS = {
  Wind, RefreshCw, CloudRain, Flame, Baby, Users, Globe, Compass, Sprout,
  Puzzle, Heart, Sparkles, Brain, Sun, Moon, Leaf, Anchor, Shield, Smile,
  Star, Feather, Waves, Mountain, Cloud, Lightbulb, Handshake, HeartHandshake,
  HandHeart, BookOpen, MessageCircle, Coffee, Home, Activity, Accessibility,
};

export const ICON_NAMES = Object.keys(TREATMENT_ICONS);
export const DEFAULT_ICON = "Sparkles";

export const getIcon = (name) => TREATMENT_ICONS[name] || TREATMENT_ICONS[DEFAULT_ICON];
